export const icons = {
  100: "#6d81a6",
  200: "#d8dffb",
}
